import React from 'react';
import { Entitlement, OrganizationForEnrollPageQuery, Permission } from '../../../graphQL';
import * as Styles from '../styles';
import { EnrollOption } from './EnrollOption';
import { useHistory } from 'react-router-dom';
import { PermsOnly } from '../../../Components/Permissions/Only';

type EnrollOptionsProps = {
  organization: OrganizationForEnrollPageQuery['organization'];
  setShowSelectionScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

export function EnrollOptionsComponent({
  organization,
  setShowSelectionScreen,
}: EnrollOptionsProps) {
  const history = useHistory();
  const entitlementsArray = organization.entitlements.map(entitlement => entitlement.key);

  return (
    <Styles.EnrollOptionsWrapper>
      {entitlementsArray.includes(Entitlement.AllowMultipleReferralTypes) && (
        // This is the "default" option, and should be included in all referral types if the AllowMultipleReferralTypes entitlement is on
        // (unless product specifies otherwise)
        // If the entitlement is off, providers won't even see this page
        <EnrollOption
          title="Mantra Clinical Care"
          label="Mantra Health"
          testId="selectDefaultReferralType"
          description="Refer a student to any of the clinical services offered through Mantra’s network of telehealth providers."
          onClick={() => setShowSelectionScreen(false)}
        />
      )}
      {entitlementsArray.includes(Entitlement.AllowCharlieHealthIopReferralsViaMcp) && (
        <PermsOnly allowed={Permission.PatientCreate}>
          <EnrollOption
            title="Virtual Intensive Outpatient Program"
            label="In Partnership with Charlie Health"
            testId="selectCharlieHealthIOPReferralType"
            description="Evidence-based programs for young people in need of a higher level of support, with comprehensive, personalized treatment plans alongside peers with common goals. 100% virtual."
            // onClick changes the page instead of state (like in the default option above)
            // That way you don't have to go through the enroll selection screen every single time if its a direct-link
            // Its a completely self-contained page
            // I recommend future entitlement-based referal options to be done this way
            onClick={() =>
              history.push(`/organizations/${organization.id}/students/enroll-option-iop`)
            }
          />
        </PermsOnly>
      )}

      {entitlementsArray.includes(Entitlement.AllowTogetherAllReferralsViaMcp) && (
        <PermsOnly allowed={Permission.PatientCreate}>
          <EnrollOption
            title="Online Peer Support"
            label="In Partnership with TOGETHERALL"
            testId="selectTogetherallReferralType"
            description="Togetherall is a safe, online community to share feelings anonymously and get support to improve mental health and wellbeing. Safely monitored by licensed & registered mental health practitioners."
            onClick={() =>
              history.push(`/organizations/${organization.id}/students/enroll-togetherall`)
            }
          />
        </PermsOnly>
      )}
    </Styles.EnrollOptionsWrapper>
  );
}
